// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3351":"516b3a73","5815":"516b3a73"}[chunkId] + ".chunk.css";
};